// removed by extract-text-webpack-plugin
module.exports = {"classtop-panel":"classtop-panel","title-section":"title-section","btn":"btn","title-content":"title-content"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Panel/Panel.scss
// module id = mgtn
// module chunks = 0